/** 등록 관련 Toast Message */
export const CREATE_SUCCESS_MESSAGE = '등록되었습니다.';
export const CREATE_ERROR_MESSAGE = '등록 중 오류가 발생했습니다.';

/** 변경 관련 Toast Message */
export const UPDATE_SUCCESS_MESSAGE = '변경되었습니다.';
export const UPDATE_ERROR_MESSAGE = '변경 중 오류가 발생했습니다.';

/** 수정 관련 Toast Message */
export const EDIT_SUCCESS_MESSAGE = '수정되었습니다.';
export const EDIT_ERROR_MESSAGE = '수정 중 오류가 발생했습니다.';

/** 삭제 관련 Toast Message */
export const DELETE_SUCCESS_MESSAGE = '삭제되었습니다.';
export const DELETE_ERROR_MESSAGE = '삭제 중 오류가 발생했습니다.';

/** 파일 다운로드 관련 Toast Message */
export const FILE_DOWNLOAD_MESSAGE = {
  pending: '파일 다운로드 중입니다.',
  success: '다운로드되었습니다.',
  error: '파일 다운로드 중 오류가 발생했습니다.',
};

/** 파일 첨부 관련 Toast Message */
export const CHECK_FILE_SIZE_MESSAGE = (size: number) =>
  `파일은 최대 ${size}mb까지 등록 가능합니다.`;
export const CHECK_MAX_FILE_COUNT_MESSAGE =
  '파일은 항목별 최대 3개까지만 등록 가능합니다.';
export const CHECK_FILE_NAME_LENGTH_MESSAGE = (length: number) =>
  `파일명은 확장자를 포함, 최대 ${length}자 이하만 가능합니다.`;
